import { createStyles, makeStyles } from '@material-ui/core/styles';

import { variables } from '@styles';
import { image } from '@content';

/**
 * Accordion component styles
 * @returns {Function}
 */
export const useStyles = makeStyles((theme) =>
  createStyles({
    accordion: {
      '&[data-type=primary]': {
        '& .MuiAccordionSummary-expandIcon': {
          backgroundImage: `url(${image.plusAccordion})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          padding: 0,
          borderRadius: 0,
          height: '1.5rem',
          width: '1.5rem',

          '&.Mui-expanded': {
            backgroundImage: `url(${image.minus})`,
            transform: 'none',
          },
        },
      },
    },

    accordionSecondary: {
      '&&': {
        backgroundColor: 'unset',
        borderBottom: `solid 1px ${variables.color.primary.lightGray}`,
        marginBottom: '0',

        '&:last-child': {
          marginBottom: '1.6rem',
        },

        '&:before': {
          display: 'none',
        },
      },
    },

    accordionTertiary: {
      position: 'unset',
      '& .MuiAccordionSummary-root': {
        justifyContent: 'flex-start',
        minHeight: 'unset',
      },
      '& .MuiAccordionSummary-content': {
        flexGrow: 0,
        minHeight: 'unset',
      },
      '& .MuiAccordionDetails-root': {
        padding: 0,
      },
    },

    accordionQuaternary: {
      '&&': {
        margin: 0,

        '& $expandIcon': {
          minHeight: 'unset',
          backgroundColor: variables.colorV2.accordion.default.background,
          border: `.1rem solid ${variables.colorV2.accordion.default.border}`,
          borderRadius: '3.4rem',
          color: variables.colorV2.accordion.default.text,
          fontSize: '2rem',
          height: '3.2rem',
          lineHeight: '3.0rem',
          padding: '0 .8rem',
        },

        '& .MuiAccordionSummary-content': {
          minHeight: '3.2rem',
        },

        '& .MuiAccordionSummary-expandIcon': {
          borderRadius: 'unset',
          padding: 0,
        },

        '& .MuiAccordionDetails-root': {
          flexDirection: 'column',
          padding: '1.6rem 1.6rem 0 1.6rem',
        },

        '&:before': {
          display: 'none',
        },
      },
    },

    expanded: {
      backgroundImage: 'none',

      '& $icon': {
        border: `${variables.borderWidth.sm} solid ${variables.color.primary.mainPurple}`,
        boxShadow: `inset 0 0 0 1px ${variables.color.primary.mainPurple}`,
      },
    },

    expandIcon: {
      '&&': {
        padding: '0',
        borderBottom: 'none',
      },

      '& .MuiAccordionSummary-expandIcon': {
        backgroundImage: 'unset',
        transform: 'rotate(180deg)',
      },

      '& .MuiAccordionSummary-expandIcon.Mui-expanded': {
        transform: 'rotate(0)',
      },
    },

    icon: {
      display: 'flex',
      padding: theme.spacing(1),
      borderRadius: variables.borderRadius.sm,
      border: `${variables.borderWidth.sm} solid ${variables.color.primary.lightGray}`,
      marginRight: theme.spacing(2),
    },

    iconSecondary: {
      marginRight: '1rem',
      display: 'flex',
      alignItems: 'center',
    },

    titleSecondary: {
      textTransform: 'capitalize',
    },

    quaternaryTitle: {
      '&&': {
        color: variables.colorV2.accordion.default.text,
        fontSize: '2rem',
        fontWeight: 400,
        letterSpacing: '0',
        lineHeight: '3rem',
        textTransform: 'none',

        [`@media (max-width: 1580px)`]: {
          fontSize: '1.4rem',
        },
      },
    },

    subtitle: {
      marginTop: theme.spacing(0.5),
      textTransform: 'capitalize',
    },

    details: {
      padding: 0,
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    iconExpanded: {
      transform: 'rotate(0deg)',
      '& path': {
        stroke: variables.colorV2.accordion.default.icon.stroke,
      },
    },

    iconClosed: {
      transform: 'rotate(180deg)',
      '& path': {
        stroke: variables.colorV2.accordion.default.icon.stroke,
      },
    },
  }),
);
